import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7775a6b3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pb-3 pt-3" }
const _hoisted_2 = { class: "is-pulled-right" }
const _hoisted_3 = { class: "custom-card-destinataire has-text-right" }
const _hoisted_4 = { class: "card-paiement-defaut-carte has-text-right mt-1" }
const _hoisted_5 = { class: "is-flex-direction-column" }
const _hoisted_6 = { class: "custom-card-destinataire" }
const _hoisted_7 = { class: "has-text-grey-light" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "custom-line-separator has-background-white-ter mb-2 mt-1" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h5", _hoisted_3, _toDisplayString(_ctx.date), 1),
        _createElementVNode("h5", _hoisted_4, _toDisplayString(_ctx.calcDays(_ctx.unformatedDate)), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h3", {
          class: _normalizeClass([
          _ctx.amount.charAt(0) == '-'
            ? 'custom-card-destinataire has-text-danger'
            : 'custom-card-destinataire has-text-success',
        ])
        }, _toDisplayString(parseFloat(_ctx.amount).toLocaleString("fr", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })) + " " + _toDisplayString(_ctx.symbol), 3),
        _createElementVNode("h4", _hoisted_6, _toDisplayString(_ctx.name), 1),
        _createElementVNode("h5", _hoisted_7, _toDisplayString(_ctx.desc), 1)
      ])
    ]),
    _hoisted_8
  ], 64))
}